<script>
export default {
    name: "UploadedMedicalFiles",

    props: {
        medDocuments: {
            type: Array,
            required: true,
        }
    },

    components: {
        'view-file': () => import('./modals/ViewFile.vue')
    },
}
</script>

<template>
    <div class="w-full p-1 my-1">
        <div class="p-1 w-full bg-indigo-300 rounded-t-md">
            <h5 class="font-bold text-white text-sm">Visit #{{ $route.params.visitNo }}</h5>
        </div>
        <div class="w-full flex flex-wrap border-r-2 border-l-2 border-b-2 border-indigo-300 
            rounded-b p-2 bg-gray-100">
            <table class="table">
                <thead class="bg-blue-500 text-white text-sm">
                    <tr>
                        <th class="p-tiny">Id</th>
                        <th class="p-tiny">Date</th>
                        <th class="p-tiny">Document</th>
                        <th class="p-tiny">Username</th>
                        <th class="p-tiny hide--print">Action</th>
                    </tr>
                </thead>
                <tbody class="text-xs bg-gray-100">
                    <tr v-for="medFile in medDocuments" :key="medFile.id">
                        <td class="p-tiny">{{ medFile.id }}</td>
                        <td class="p-tiny">{{ medFile.date | dateFormat }}</td>
                        <td class="p-tiny">{{ medFile.docName }}</td>
                        <td class="p-tiny">{{ medFile.userName }}</td>
                        <td class="p-tiny hide--print">
                            <button
                                @click.prevent="medFile.view = true"
                                class="btn-sm btn-info rounded m-px">
                                    <i class="fa fa-eye"></i> View</button>
                            <view-file 
                                :showModal="medFile.view"
                                :file="medFile"
                                @closeModal="medFile.view=false"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<style scoped>
    @media print {
        .hide--print {
            display: none;
        }
    }
</style>
